import { useState } from "react";
import { useNavigate } from "react-router-dom";
import HeroLandingPage from "../../assets/icons/hero-landingPage.png";
import FipayLogo from "../../assets/icons/fipaylogo.png";
import { emailRegex } from "../../utils/EmailValidation";

import {
  LoginContainer,
  HeroBackgroundImage,
  HeaderContainer,
  LoginGrid,
  LoginForm,
  LoginImage,
  LoginModalContainer,
  LoginInformation,
  LoginAccountText,
  InputContainer,
  ForgotPasswordContainer,
  ForgotPasswordText,
  LoginButtonContainer,
  CreateAccountContainer,
  CreateAccountText,
  SubText,
  ImageCard,
} from "./login.styles";
import TextFields from "../../components/TextField/text-field.component";
import Buttons from "../../components/Button/button.component";
import { colors } from "../../theme/color";
import Stepper from "../../components/Stepper";
import { LoginFormValues } from "../../pages/Login";

interface LoginProps {
  handleLogin: () => void;
  formData: LoginFormValues;
  setFormData: React.Dispatch<React.SetStateAction<LoginFormValues>>;
  isLoading?: boolean;
  errorMessage?: string;
}
const Login: React.FC<LoginProps> = ({
  handleLogin,
  formData,
  setFormData,
  isLoading,
  errorMessage,
}) => {
  const [phone, setPhone] = useState("");
  const navigate = useNavigate();
  const [isValidEmail, setIsValidEmail] = useState(true);

  const handleChange = (key: keyof LoginFormValues, value: string) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));
  };
  const NavigateToTypeOfAccount = () => {
    navigate("/auth/type-of-account");
  };

  const NavigateToForgotPassword = () => {
    navigate("/forgot-password");
  };

  const toHomePage: () => void = () => {
    navigate("/");
  };

  const isFormValid = () => {
    return formData.email !== "" && formData.password !== "" && isValidEmail;
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleLogin();
  };
  return (
    <LoginContainer>
      <HeroBackgroundImage>
        <img alt={"Hero landing"} src="/assets/icons/hero-landingPage.png" />
      </HeroBackgroundImage>
      <HeaderContainer>
        <img
          alt={"Hero landing"}
          onClick={toHomePage}
          src="/assets/icons/fipaylogo.png"
        />
      </HeaderContainer>
      <LoginGrid>
        <LoginImage>
          <Stepper />
        </LoginImage>
        <LoginForm>
          <LoginModalContainer>
            <LoginInformation>Welcome Back</LoginInformation>
            <LoginAccountText>
              To log in, please type in your email and password
            </LoginAccountText>
            <form onSubmit={handleSubmit}>
              <InputContainer>
                <TextFields
                  type="email"
                  placeholder="example@company.com"
                  label="Email Address"
                  value={formData.email}
                  onChange={(value: string) => handleChange("email", value)}
                />
                <TextFields
                  type="password"
                  placeholder="●●●●●●●●"
                  label="Password"
                  value={formData.password}
                  onChange={(value: string) => handleChange("password", value)}
                />
              </InputContainer>
              <ForgotPasswordContainer>
                <ForgotPasswordText onClick={NavigateToForgotPassword}>
                  Forgot Password?
                </ForgotPasswordText>
                {errorMessage && <p style={{ color: "red" }}>{errorMessage}</p>}
              </ForgotPasswordContainer>
              <LoginButtonContainer>
                <Buttons
                  label={"Sign in"}
                  width="95%"
                  color={colors.ButtonBackgroundColors.primaryMediumHoverButton}
                  cursor="pointer"
                  border="25px"
                  height="50px"
                  disabled={!isFormValid()}
                />
              </LoginButtonContainer>
            </form>
            <CreateAccountContainer>
              <CreateAccountText>
                Don’t have an account?{" "}
                <SubText onClick={NavigateToTypeOfAccount}>
                  Create an account
                </SubText>
              </CreateAccountText>
            </CreateAccountContainer>
          </LoginModalContainer>
        </LoginForm>
      </LoginGrid>
    </LoginContainer>
  );
};
export default Login;
